import ShareableLinkPath from './ShareableLinkPath.component';

export default ShareableLinkPath;